import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProductsById } from 'shared/api/masters'
import { Box, Button, Link } from '@mui/material'
import { TreeManagement } from './tree/TreeManagement'
import React from 'react'
import { useCheckTreeAttributions } from './MasterManagement'
import { useToggleState } from 'shared/hooks'
import { AttributionEdit } from './tree/LeafView'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { directTreeAccessUrl } from 'infrastructure/api'

export function EditableCopyView({ productId }: { productId: number }) {
  const product = useAtomValue(allProductsById)[productId]
  if (!product?.editable_tree) return null
  const { tree_id: treeId, version_id: versionId } = product.editable_tree
  return (
    <Box padding="5px" border={'1px solid'}>
      <Box>
        Editable Copy: <TreeLink treeId={treeId} versionId={versionId} />
      </Box>
      <Box>
        <CheckTreeAttribution
          treeId={treeId}
          versionId={versionId}
          title={'Attribution'}
        />
      </Box>
      <TreeManagement treeId={treeId} versionId={versionId} />
    </Box>
  )
}

function CheckTreeAttribution({
  title,
  ...ids
}: {
  treeId: string
  versionId: string
  title: string
}) {
  const [editing, toggleEditing] = useToggleState(false)
  const validationData = useCheckTreeAttributions(ids)
  if (!validationData) return <Box>Loading...</Box>
  const { attributions, valid, tree } = validationData
  return (
    <Box>
      {title}{' '}
      <span style={{ color: valid ? 'green' : 'red' }}>
        {attributions.length ? attributions.join(', ') : 'MISSING'}
      </span>
      <Button onClick={() => toggleEditing()}>Edit</Button>
      {editing && <AttributionEdit parentNode={tree} />}
    </Box>
  )
}

function TreeLink(ids: { treeId: string; versionId: string }) {
  const { tree } = useGetTreeById({ ...ids, depth: 0 })
  if (!tree) return null
  return (
    <Box
      component={Link}
      href={directTreeAccessUrl(ids)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {tree.title}
    </Box>
  )
}
